import type { ZudokuPlugin } from 'zudoku';

declare global {
  interface Window {
    dataLayer?: Record<string, any>[];
    gtag?: (...args: any[]) => void;
  }
}

const gaId = process.env.ZUDOKU_GA_ID;

export const analyticsPlugin: ZudokuPlugin | undefined = gaId
  ? {
      getHead: () => (
        <>
          <script async src={`https://www.googletagmanager.com/gtag/js?id=${gaId}`} />
          <script>
            {`window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${gaId}', { page_path: window.location.pathname });`}
          </script>
        </>
      ),
      events: {
        location: ({ from, to }) => {
          if (!from || !window.gtag) return;
          window.gtag('config', gaId, {
            page_path: to.pathname,
            page_location: window.location.href,
            page_title: document.title,
          });
        },
      },
    }
  : undefined;